var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.473,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.472 6.3H6.3V4.5c0-.929.076-1.514 1.407-1.514h1.681V.124A23.459 23.459 0 006.924 0 3.937 3.937 0 002.7 4.229V6.3H0v3.6h2.7V18h3.6V9.9h2.759z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/facebook_full.26bdaea9f27acf3f2ce5d5abcd093e45.svg";
export { SvgFacebookFull as ReactComponent };